import { ReactComponent as LogoImg } from '~assets/fretebras-logo.svg';
import Wrapper from './styled';
import { Props } from './types';

function ContractibleLogo({ isContracted = false, className }: Props) {
  return (
    <Wrapper $isContracted={isContracted} className={className}>
      <LogoImg />
    </Wrapper>
  );
}

export default ContractibleLogo;
